import React from "react";

import { Helmet } from "react-helmet";

import './Julbord.css';
import Button from "../../components/button/Button";
import { openReservation } from "../../utils/analytics";

export const Julbord: React.FC = (): JSX.Element => {
    return (
        <>
            <Helmet>
                <title>Julbord - Hallwylska Restaurang</title>
                <meta name="description" content="Celebrate the festive season with Hallwylska Restaurang's traditional Julbord. Join us for a delightful Christmas feast starting November 20th." />
                <link rel="canonical" href="https://hallwylskarestaurang.com/julbord" />
                <meta property="og:title" content="Julbord - Hallwylska Restaurang" />
                <meta property="og:description" content="Celebrate the festive season with Hallwylska Restaurang's traditional Julbord. Join us for a delightful Christmas feast starting November 20th." />
                <meta property="og:url" content="https://hallwylskarestaurang.com/julbord" />
                <meta name="twitter:title" content="Julbord - Hallwylska Restaurang" />
                <meta name="twitter:description" content="Celebrate the festive season with Hallwylska Restaurang's traditional Julbord. Join us for a delightful Christmas feast starting November 20th." />
                
            </Helmet>
            <section className="julbord beige-bg pt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-xl-5 offset-xl-1 d-flex justify-content-center order-md-1 order-2">
                            <img src="/img/julbord.webp"
                                alt="Hallwylska's julbord"
                                className="fly-left julbord__image"/>
                        </div>
                        <div className="col-md-6 col-xl-5 order-md-2 order-1 fly-right">
                            <h1 className="text-green">Hallwylska julbord 2026</h1>
                            <p>Välkommen till en magisk julupplevelse på Hallwylska! Vår traditionella julbuffé serveras från 20 november fram till julafton, fylld med klassiska svenska julrätter och säsongens bästa smaker.</p>
                            
                            <h4 className="julbord__subtitle">Priser & Tider</h4>

                            <div className="julbord__card">
                                <div className="julbord__card-head">
                                    <h5 className="julbord__month">November</h5>
                                    <span className="julbord__period">20–30 nov</span>
                                </div>
                                <div className="julbord__price">
                                    <div className="julbord__price-head">
                                        <span className="julbord__price-name">Lunch</span>
                                        <span className="julbord__price-amount">595 kr</span>
                                    </div>
                                    <p className="julbord__price-time">Mån–sön 11:30 - 12:00 Bokningsbart, 2,5 h sittning</p>
                                </div>
                                <div className="julbord__price">
                                    <div className="julbord__price-head">
                                        <span className="julbord__price-name">Mellan</span>
                                        <span className="julbord__price-amount">745 kr</span>
                                    </div>
                                    <p className="julbord__price-time">Mån–sön 15:00 - 15:30 Bokningsbart, 2,5 h sittning</p>
                                </div>
                                <div className="julbord__price">
                                    <div className="julbord__price-head">
                                        <span className="julbord__price-name">Kväll</span>
                                        <span className="julbord__price-amount">995 kr</span>
                                    </div>
                                    <p className="julbord__price-time">Mån–sön 19:30 - 20:30 Bokningsbart, 2,5 h sittning</p>
                                </div>
                            </div>

                            <div className="julbord__card">
                                <div className="julbord__card-head">
                                    <h5 className="julbord__month">December</h5>
                                    <span className="julbord__period">1–24 dec</span>
                                </div>
                                <div className="julbord__price">
                                    <div className="julbord__price-head">
                                        <span className="julbord__price-name">Lunch</span>
                                        <span className="julbord__price-amount">695 kr</span>
                                    </div>
                                    <p className="julbord__price-time">Mån–sön 11:30 - 12:00 Bokningsbart, 2,5 h sittning</p>
                                </div>
                                <div className="julbord__price">
                                    <div className="julbord__price-head">
                                        <span className="julbord__price-name">Mellan</span>
                                        <span className="julbord__price-amount">845 kr</span>
                                    </div>
                                    <p className="julbord__price-time">Mån–sön 15:00 - 15:30 Bokningsbart, 2,5 h sittning</p>
                                </div>
                                <div className="julbord__price">
                                    <div className="julbord__price-head">
                                        <span className="julbord__price-name">Kväll</span>
                                        <span className="julbord__price-amount">1095 kr</span>
                                    </div>
                                    <p className="julbord__price-time">Mån–sön 19:30 - 20:30 Bokningsbart, 2,5 h sittning</p>
                                </div>
                                <div className="julbord__price julbord__price--highlight">
                                    <div className="julbord__price-head">
                                        <span className="julbord__price-name">Julafton</span>
                                        <span className="julbord__price-amount">1095 kr</span>
                                    </div>
                                    <p className="julbord__price-time">11:30 - 15:00, stänger 15.00</p>
                                </div>
                            </div>

                            <h4 className="julbord__subtitle">Övrigt</h4>
                            <p>
                                <strong>Barn:</strong> 35kr per fyllt år upp till 10 år<br />
                                <strong>Hundar:</strong> Välkomna
                            </p>
                            
                            <p className="julbord__note">
                                Har du allergier eller specialkost? Kontakta oss gärna i förväg så hjälper vi dig på bästa sätt.
                            </p>
                            <p className="text-center">
                                <Button text='Make a Reservation'
                                        class_type="primary"
                                        onClick={() => openReservation('julbord')}/>
                            </p>
                            <p className="julbord__group-booking text-center">
                                För större bokningar över 20 personer eller abonnering vänligen kontakta <a className="julbord__group-booking-link" href="mailto:elliot.gordon@frenchgroup.se">elliot.gordon@frenchgroup.se</a>
                            </p>
                        </div>
                    </div>
                </div>
                {/* <div className="flex">
                        <img src="/img/menu/julbord.png" alt="Hallwylska's julbord" className="mt-5 w-100"/>
                    </div> */}
            </section>
        </>
    );
  };